import React from 'react';

/**
 * Ô tìm kiếm item theo ID hoặc tên (dùng chung 6 trang shop).
 *
 * Chỉ là UI. Việc lọc chạy ở component cha, trên TOÀN BỘ danh sách đã tải
 * (nên tìm được cả item chưa cuộn tới).
 */
export default function ShopToolbar({ keyword, onKeywordChange }) {
    const hasKeyword = !!keyword;

    return (
        <div className="d-inline-flex align-items-center shop-toolbar">
            <div className="input-group shop-search">
                <div className="input-group-prepend">
                    <span className="input-group-text">
                        <i className="fa fa-search" aria-hidden="true" />
                    </span>
                </div>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Tìm theo ID hoặc tên..."
                    value={keyword}
                    onChange={(e) => onKeywordChange(e.target.value)}
                />
                {/*
                 * Nút xoá LUÔN nằm trong DOM (chỉ ẩn/hiện) và được PHỦ bên trong ô input
                 * -> bề rộng ô tìm kiếm không thay đổi khi bắt đầu gõ / xoá hết chữ.
                 * KHÔNG dùng class .btn vì theme admin có .btn{border:none;padding:10px 20px}
                 * làm nút mất viền và bị đẩy ra xa mép ô.
                 */}
                <button
                    type="button"
                    className={'shop-clear-btn' + (hasKeyword ? '' : ' is-hidden')}
                    title="Xoá tìm kiếm"
                    aria-label="Xoá tìm kiếm"
                    tabIndex={hasKeyword ? 0 : -1}
                    onClick={() => onKeywordChange('')}
                >✕</button>
            </div>
        </div>
    );
}
